import * as React from "react";
import { cn } from "@/modern/utils";
import { CommandItem } from "@/modern/components/ui/command";

const itemOuterCls =
  "group flex cursor-pointer flex-col justify-center rounded-lg !p-0 bg-transparent text-foreground outline-none ring-0 focus-visible:outline-none focus-visible:ring-0 !data-[selected=true]:bg-transparent aria-selected:!bg-transparent data-[selected=true]:text-foreground";

const itemHighlightCls =
  "flex h-full w-full items-center rounded-lg transition-colors group-data-[selected=true]:bg-accent group-aria-selected:bg-accent";

interface EntityFinderListItemProps extends React.ComponentPropsWithoutRef<typeof CommandItem> {
  absolute?: boolean;
}

export function EntityFinderListItem({
  children,
  className,
  style,
  absolute = false,
  ...props
}: EntityFinderListItemProps) {
  return (
    <CommandItem
      {...props}
      style={style}
      className={cn(
        itemOuterCls,
        absolute ? "absolute inset-x-2 top-0 py-0.5" : "mx-2 py-0.5",
        className
      )}
    >
      <div className={itemHighlightCls}>{children}</div>
    </CommandItem>
  );
}
